export enum HttpMethods {
    Get = 'get',
    Post = 'post'
}